import gql from "graphql-tag";

export const WWW_OTA_BOOKING_QUERY = gql`
  query OTABookingQuery($bookingUniqKey: String!) {
    otaBooking(bookingUniqKey: $bookingUniqKey) {
      guestInfo {
        email
        firstName
        lastName
        countryAlpha2
        countryCode
        phoneNumber
        dateOfBirth
        isBgcNeeded
      }
      productInfo {
        image
        title
        subtitle
        checkInDateLabel
        checkOutDateLabel
        numberOfNights
        stayLengthLabel
      }
      inquiry {
        account {
          id: normalizedId
        }
        id: normalizedId
      }
    }
  }
`;
